<template>
  <div>
    <divcard>
      <div class="d-flex">
        <div :style="{ 'width': headers[0].width }" class="d-flex justify-center gap-4">
          <v-btn small icon @click="eventEdit">
            <Iconify
                color="var(--theme-color-one)"
                icon="mdi:clock"
                size="20px"
            ></Iconify>
          </v-btn>
        </div>

        <div
            class="font-type-bold"
            :style="{ 'width': headers[1].width }"
            :class="[ 'text-' + (headers[1].align ? headers[1].align : 'start') ]"
        >
          1
        </div>
        <div
            class="font-type-bold"
            :style="{ 'width': headers[2].width }"
            :class="[ 'text-' + (headers[2].align ? headers[2].align : 'start') ]"
        >
          {{ item.plan_master.plan_code }}
        </div>
        <div
            :style="{ 'width': headers[3].width }"
            :class="[ 'text-' + (headers[3].align ? headers[3].align : 'start') ]"
        >
          <div class="font-type-bold one-line mb-3" style="height: 20px">{{ item.plan_master.plan_name_th }} {{ item.plan_master.plan_name_en }}</div>
          <div
              v-for="(r, ind) in item.project_accept_rounds"
              :key="ind"
              class="mb-1"
          >
            รอบที่ {{ r.round }} : {{ toDateRangeFormat(r.start_date, r.end_date) }}
          </div>
        </div>
        <div
            :style="{ 'width': headers[4].width }"
            :class="[ 'text-' + (headers[4].align ? headers[4].align : 'start') ]"
        >
          <div class="font-type-bold mb-3">{{ item.project_accept_rounds.map(x => x.form_c_count).reduce((a, b) => a + b, 0) }}</div>
          <div
              v-for="(r, ind) in item.project_accept_rounds"
              :key="ind"
              class="mb-1"
          >
            {{ r.form_c_count }}
          </div>
        </div>
        <div
            :style="{ 'width': headers[5].width }"
            :class="[ 'text-' + (headers[5].align ? headers[5].align : 'start') ]"
        >
          <div class="theme-color-one font-type-bold mb-3">{{ formatNumber(item.project_accept_rounds_sum_budget, 2) }}</div>
          <div
              v-for="(r, ind) in item.project_accept_rounds"
              :key="ind"
              class="mb-1"
          >
            {{ formatNumber(r.budget, 2) }}
          </div>
        </div>

      </div>
    </divcard>
  </div>
</template>

<script>
import { formatNumber, toDateRangeFormat } from "../plugins/global-funcs"

export default {
  name: "AvailablePlanItem",
  components: {
  },
  props: {
    item: {
      default: () => ({})
    },
    headers: {
      default: () => ([])
    }
  },
  data () {
    return {
      formatNumber,
      toDateRangeFormat
    }
  },
  methods: {
    eventEdit () {
      this.$emit('onEdit')
    }
  }
}
</script>

<style scoped lang="scss">
.left-side {
  min-width: 40px;
  max-width: 40px;
}

.btn-pos {
  position: absolute;
  bottom: 24px;
  right: 24px;
}

.expand-layout {
  -moz-transition: height .2s;
  -ms-transition: height .2s;
  -o-transition: height .2s;
  -webkit-transition: height .2s;
  transition: height .2s;
  height: 0;
  overflow: hidden;
}
.expand-content {
  padding: 24px;
  background: #FAFAFA;
  box-shadow: 1px 1px 20px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 20px 20px;
}
</style>